import { action } from 'satcheljs';

export const tryStartTrial = action('tryStartTrial', (onTrialStarted: () => void) => ({
    onTrialStarted: onTrialStarted,
}));

export const setPremiumTemporarilyEnabled = action(
    'setPremiumTemporarilyEnabled',
    (enabled: boolean) => ({
        enabled: enabled,
    })
);

export const startPremiumPreviewTimeBased = action(
    'startPremiumPreviewTimeBased',
    (daysLeft: number) => ({
        daysLeft: daysLeft,
    })
);

export const updatePremiumPreviewCountBased = action(
    'updatePremiumPreviewCountBased',
    (numerSuggestionsLeft: number) => ({
        numerSuggestionsLeft: numerSuggestionsLeft,
    })
);
